var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKıdsgırldaıre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    strokeWidth: 0,
    d: "M22.68,11.34c0,6.26-5.08,11.34-11.34,11.34S0,17.6,0,11.34,5.08,0,11.34,0s11.34,5.08,11.34,11.34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKıdsgırldaıre);
export default __webpack_public_path__ + "static/media/KIDSGIRLDAIRE.2dbd94364beeb31ac44ea4bb75959980.svg";
export { ForwardRef as ReactComponent };